import { type FormStore, getError } from '@modular-forms/solid'

export const isSectionValid = <T extends Record<string, any>>(
	form: FormStore<T, undefined>,
	fields: Array<keyof T>,
) => {
	// A section is valid if NONE of its fields have an error registered in the form store
	return !fields.some((field) => !!getError(form, field as any))
}
